import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';

export const TransferValueComparisonAnual = () => {
    const { chartData } = useValuesChartsDataContext();

    const series = [
        {
            name: 'Valor',
            data: chartData?.transferValueComparisonAnual?.map(item => item.transfer_value)
        },
        {
            name: 'Diferença',
            data: chartData?.transferValueComparisonAnual?.map(item => item.difference)
        },
        {
            name: 'Teto',
            data: chartData?.transferValueComparisonAnual?.map(item => item.transfer_ceiling)
        }
    ];

    const categories = chartData?.transferValueComparisonAnual?.map(item => getYearLabel(item.ano));

    return (
        <SimpleBars
            title={'Comparação Valor de Repasse (Anual)'}
            horizontal={false}
            stacked
            subtitles={categories}
            series={series}
            showDataLabels={false}
        />
    );
};
